/**
 * 当前使用的vue-router3不支持 composition-api，route4不支持vue2.7
 * 采取 vue-router3 + composition-api 支持setup
 */
import { getCurrentInstance } from 'vue';

export function useRoute() {
  // const { proxy } = getCurrentInstance?.();
  return getCurrentInstance?.()?.proxy?.$route || {};
}
export function useRouter() {
  // const { proxy } = getCurrentInstance?.();
  return getCurrentInstance?.()?.proxy?.$router || {};
}
